var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconExternal = function SvgIconExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    d: "M3.5 7A3.5 3.5 0 0 1 7 3.5h4.667a1.167 1.167 0 0 1 0 2.333H7c-.644 0-1.167.523-1.167 1.167v14c0 .644.523 1.167 1.167 1.167h14c.644 0 1.167-.523 1.167-1.167v-4.667a1.167 1.167 0 1 1 2.333 0V21a3.5 3.5 0 0 1-3.5 3.5H7A3.5 3.5 0 0 1 3.5 21zm14-1.167a1.167 1.167 0 0 1 0-2.333h5.833c.645 0 1.167.522 1.167 1.167V10.5a1.167 1.167 0 0 1-2.333 0V7.483l-7.342 7.342a1.167 1.167 0 0 1-1.65-1.65l7.342-7.342z",
    clipRule: "evenodd"
  })));
};
export default SvgIconExternal;